import { usePageTitle } from '@/hooks/use-page-title';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useLogout } from '@/features/auth/use-auth-mutations';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { useProfileEdit } from '@/platform/features/profile/profile-edit-context';
import { ProfilePageShell } from '@/platform/features/profile/profile-shared';

export function ProfileSecurityPage() {
  usePageTitle('Sicherheit · Profil');
  const { profile } = useProfileEdit();
  const logout = useLogout();

  return (
    <ProfilePageShell>
      <PlatformPageHeader title="Sicherheit" description="Anmeldung und Abmelden." />

      <Card>
        <CardHeader>
          <CardTitle>Sicherheit</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          {profile.hasLocalPassword ? (
            <>
              <p>Anmeldung mit lokalem Passwort.</p>
              <p>Zwei-Faktor-Anmeldung: {profile.totpEnabled ? 'aktiv' : 'nicht aktiviert'}.</p>
            </>
          ) : (
            <p>Anmeldung über Microsoft 365.</p>
          )}
          <Button
            type="button"
            variant="outline"
            disabled={logout.isPending}
            onClick={() => {
              void logout.mutateAsync();
            }}
          >
            Abmelden
          </Button>
        </CardContent>
      </Card>
    </ProfilePageShell>
  );
}
